export const fio = deputy => `${deputy.lastName || ''} ${deputy.firstName || ''} ${deputy.middleName || ''}`;
